<script setup lang="ts">
import { QItem, QItemLabel, QItemSection } from 'quasar'
import { computed } from 'vue'
import { CountryISO3, Language } from '@previo/codebooks'
import { Locales } from '@previo/core'
import PFlag from '../flag/PFlag.vue'
import { PFlagSize } from '../flag/types'
import PTextLink from '../typography/links/PTextLink.vue'

type Props = {
  text: string
  languageShortcut: Locales
  clickable?: boolean
  cy: string
}

const props = withDefaults(defineProps<Props>(), {
  clickable: false,
})

const flagSpecification = computed<CountryISO3>(() => {
  return Language.getByLocale(props.languageShortcut).countryISO3
})
</script>

<template>
  <q-item :clickable="clickable" :data-cy="cy">
    <q-item-section avatar>
      <p-flag :country-iso3="flagSpecification" :size="PFlagSize.SMALL" />
    </q-item-section>

    <q-item-section>
      <q-item-label>
        <p-text-link :text="text" />
      </q-item-label>
    </q-item-section>
  </q-item>
</template>
